require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./too-drunk-to-be-trying-to-work.json") })
        }
      }, "path---too-drunk-to-be-trying-to-work");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---too-drunk-to-be-trying-to-work!./.cache/json/too-drunk-to-be-trying-to-work.json
// module id = 577
// module chunks = 231608221292675